<template>
  <div class="games_area">

    <div class="row">
      <div class="col-md-12">
        <div class="box">
          <h3 class="title">قائمة الألعاب</h3>
          <div class="search_area">
            <i class="fas fa-search"></i>
            <input type="text" name="" placeholder="...بحث عن لعبة">
          </div>
          <div class="box_inner">
            <table class="table table-responsive">

              <thead class="">
                <tr>
                  <th>إسم اللعبة</th>
                  <th>تعديل</th>
                  <th>مسح</th>
                </tr>
                </thead>

                <tbody>
                  <tr>
                    <td scope="row">الذاكرة الحديدية</td>
                    <td class="edit"><i class="far fa-edit"></i></td>
                    <td class="trash"><i @click="popup_removegames = !popup_removegames" class="far fa-trash-alt"></i></td>
                  </tr>
                  <tr>
                    <td scope="row">نورت البيت</td>
                    <td class="edit"><i class="far fa-edit"></i></td>
                    <td class="trash"><i @click="popup_removegames = !popup_removegames" class="far fa-trash-alt"></i></td>
                  </tr>
                </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>

    <a @click="popup_addgames = !popup_addgames" class="addgames">
      <span class="icon"><i class="fas fa-plus"></i></span>
      <span class="text">إضافة لعبة</span>
    </a>

    <div v-if="popup_addgames" id="exampleModalCenter" class="popup_add_games modal fade show" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" style="display: block; padding-right: 17px;">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h2 class="modal-title">إضافة لعبة</h2>
            <p class="subtitle mb-4">من فضلك قم بكتابة البيانات التالية</p>
            <div class="form_area">

              <div class="form-group row">
                <div class="col-md-6">
                  <input type="text" class="form-control g_name" placeholder="إسم اللعبة...">
                </div>
                <div class="col-md-6">
                  <select name="" class="form-control g_type">
                    <option value="" selected>نموذج اللعبة</option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-6">
                  <input type="text" class="form-control g_q" placeholder="إضافة سؤال...">
                </div>
                <div class="col-md-6">
                  <div class="form-group text-right">
                    <label>مدة السؤال</label>
                    <input type="number" class="form-control" placeholder="الوقت بالثواني">
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-12">
                  <div class="form-group text-right">
                    <label>الدرجات</label>
                  </div>

                  <div v-for="(item, index) in 4" :key="index" class="form-group row grades">
                    <div class="col-md-2"><input type="number" class="form-control" placeholder="من..."></div>
                    <div class="col-md-2"><input type="number" class="form-control" placeholder="إلي..."></div>
                    <div class="col-md-1"></div>
                    <div class="col-md-4">
                      <select name="" class="form-control g_relt_type">
                        <option value="" selected>نوع الإرتباط</option>
                      </select>
                    </div>
                  </div>

                </div>
              </div>

              <p class="alert text-right text-danger"> * لقد تكرر الرقم مرتين في نفس النطاف</p>

            </div>
          </div>
          <div class="m_footer">
            <button type="button" class="btn but_green">إضافة تصميم</button>
            <button @click="popup_addgames = !popup_addgames" type="button" class="btn but_dark mr-2">إلغاء</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="popup_removegames" id="exampleModalCenter" class="popup_remove_games modal fade show" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" style="display: block; padding-right: 17px;">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-5">
          <div class="modal-body">
            <img src="@/assets/images/conf.png" alt="">
            <h4 class="modal-title pt-4">تأكيد مسح</h4>
            <p class="subtitle mb-5">هل أنت متأكد من مسح بيانات اللعبة</p>
          </div>
          <div class="m_footer">
            <button type="button" class="btn but_green">متأكد</button>
            <button @click="popup_removegames = !popup_removegames" type="button" class="btn but_dark mr-2">رجوع</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    name: 'games',

    data() {
      return {
        popup_addgames: false,
        popup_removegames: false

      }
    },

    methods: {
      // addgames: function () {
      //   this.popup_addgames = true
      // }
    },

  }
</script>

<style lang="scss" scoped>

</style>
